import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export type ConfirmModalParams = {
  icon: string;
  level: ModalLevel;
  page: ModalPage;
  text?: string;
  title: string;
  confirmText: string;
  themeColor: string;
}

type ModalLevel = 'normal' | 'warning' | 'danger';

type ModalPage = 'readings' | 'charts' | 'alerts' | 'reports';

@Component({
    selector: 'app-confirm-dialog-modal',
    templateUrl: './confirm-dialog-modal.component.html',
    styleUrls: ['./confirm-dialog-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDialogModalComponent {

  @Input()
  title: string;

  @Input()
  text: string;

  @Input()
  confirmText: string;

  @Input()
  icon: string;

  @Input() themeColor: string;

  @Input()
  level: ModalLevel;

  @Input()
  page: ModalPage;

  constructor (public modal: NgbActiveModal) {
  }
}
